


import '../app/TalenCard.scss'
import ReadMore from "../../images/Icon-feather-arrow-right.png"
import { Link } from 'react-router-dom';


function TalentCard({ image, to = '/hire-talent/typing-jobs/1234', title, desc, allDesc, profilePic, profileName, locationPic = undefined, location = undefined, pay = undefined, payUnit = undefined, readMore = false, compactMode = false }) {

    return (
        <div className="talent-card-wrp">
            <Link  reloadDocument={true} className='talent-reference' to={to}>
                <div className="talent-board-container">
                    <div className='talent-img-root'>
                        {image && <img className="talent-card-img" src={image} alt='talen-1' />}
                        <div>
                            {title && <div className="talent-title">{title}</div>}
                            <div className="talent-desc">{desc}</div>
                            <div className="talent-all-desc">{allDesc}</div>
                        </div>
                    </div>
                    <div className="talen-profile-wrp">
                        <img className="talent-profile-img" src={profilePic} alt='profile-pic' />
                        <div className='profile-pay-wrp'>
                            <div className="profile-name-wrp">
                                <div className="profile-name">{profileName}</div>
                                {location && <div className="location-wrp">
                                    <img className="location-img" src={locationPic} alt='location-pic' />
                                    <div className="location-name">{location}</div>
                                </div>}
                            </div>
                            {pay && payUnit && <div className="pay-wrp">
                                <span className="pay">{pay}/</span><span className="unit">{payUnit}</span>
                            </div>}
                        </div>
                    </div>
                    {readMore && <div className='read-more-wrp'>
                        <div className='read-more'>Read More</div>
                        <img src={ReadMore} alt='read-more' />
                    </div>}
                </div>
            </Link>
        </div>
    );
}

export default TalentCard;